// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"DragDropZone_dropzone__1k-jP","filesContainer":"DragDropZone_filesContainer__3ZLXC","file":"DragDropZone_file__2s8sD","fileName":"DragDropZone_fileName__3IRrd"};